// extracted by mini-css-extract-plugin
export default {"badge":"NeutralBadge_badge__U6LJZ","amount":"NeutralBadge_amount__9tbj3"};